import { render, staticRenderFns } from "./BtnAttach.vue?vue&type=template&id=562c88a8&"
import script from "./BtnAttach.vue?vue&type=script&lang=js&"
export * from "./BtnAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports